import { render, staticRenderFns } from "./HelpChild.vue?vue&type=template&id=1422e6de&scoped=true"
import script from "./HelpChild.vue?vue&type=script&lang=js"
export * from "./HelpChild.vue?vue&type=script&lang=js"
import style0 from "./HelpChild.vue?vue&type=style&index=0&id=1422e6de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422e6de",
  null
  
)

export default component.exports